
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0c34"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0c34"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8F9Ib", function(module, exports) {

$parcel$export(module.exports, "blogs", () => $64e9af93c06761bd$export$6bd6cfc8d41f7be7);

const $64e9af93c06761bd$var$gbaImg = new URL((parcelRequire("6Q70Z"))).href;

const $64e9af93c06761bd$var$cardsImg = new URL((parcelRequire("1qv1G"))).href;

const $64e9af93c06761bd$var$dccImg = new URL((parcelRequire("6gAfJ"))).href;

const $64e9af93c06761bd$var$nesImg = new URL((parcelRequire("iEm8A"))).href;
const $64e9af93c06761bd$export$6bd6cfc8d41f7be7 = {
    "2026-06-06": {
        title: "My First Post",
        link: "firstpost",
        description: "I've created a blog page!",
        body: "Hello everyone! This is my first blog post. As the description says, it's just a place I can talk about random things. It could be able Computer Science or not, it truly will be random, but I think I'll enjoy this and I'll try to keep this up! I know this page isn't styled yet (if you are seeing it in June... but I'm working on it!)"
    },
    "2026-06-08": {
        title: "Getting Back Into Fortnite",
        link: "fortnite_again",
        description: "Fortnite is kind of fun again...",
        body: "I know this is super random, but my friends and I have been getting back into Fortnite. I played it basically since it came out. I started playing in Chapter 1 Season 3, when my brother gave me a playstation when he moved to pc gaming. However, I stopped playing when I got to college because college is BUSY! I basically have no time to do stuff while I'm in college, but now that I'm back at home I just started playing and it's been a lot of fun. I've been playing with some friends and that's been a blast too. I know this is a random post, but this will continue to just be an outlet where I can ramble on about random stuff. Thanks for reading :) "
    },
    "2026-06-14": {
        title: "Birthday Weekend!",
        link: "birthday_2026",
        description: "My birthday week/weekend was an absolute blast",
        body: "My birthday was on June 10th and it was the good ol' 21. What a week it has been. My birthday was great, we went out to eat and I got some cool things. Now one of the coolest things that I got for my birthday was a GameCube. It was on a whim, but I had some birthday cash and before my birthday I kept eyeing up a GameCube, but I never pulled the trigger. The day after my birthday I went to my local retro video game store, Halcyon Videogames. Along with the GameCube I picked up Super Mario Sunshine and this has been a blast so far! I know there are ways to play it on the switch or just emulate it, but playing on the actually hardware is amazing. Especially if I get games like Double Dash and the Mario Party games it will be a lot easier to play on authentic hardware, but it doesn't stop there. On my way back to my girlfriend's house, she was scrolling on Facebook, and she saw that a GameBoy Advanced was advertised from our local thrift store for 15 bucks. 15 BUCKS. So we went straight over there and I bought it and it WORKS. IT WORKS. It's been an insane birthday week and now my love for retro video games has gone even stronger and the hunt for more games and consoles begin! Thanks for reading :)"
    },
    "2026-06-30": {
        title: "Modding My GBA",
        link: "GBA_mod",
        description: "Remember the GBA I got? I gave it a little upgrade...",
        body: "Shortly after I bought the GBA, I started thinking about what I could do with this little thing, because there was no way I was keeping it as-is. I did some research and found out you can swap in a new LCD screen and a new shell, so I watched some videos on YouTube, found a color I liked, and ordered a non-solder kit. It took a while to get here, but when it did, I was SOOOO excited. I was hanging out with friends that day, but before everyone got together I went ahead and swapped out the case and put in the new screen, and the upgrade makes the GBA feel insane. Before doing the upgrade, I bought Super Mario Land 2: 6 Golden Coins just to make sure the GBA worked, but I replayed it after replacing the screen so I could actually see what I was doing! My friend Ilya (the goat) also lent me a copy of Pok\xe9mon Mystery Dungeon: Red Rescue Team, so I've been playing that off and on. The new screen also has two touchpads that let you adjust the brightness or cycle the screen color, though why I'd want to do that, no idea, but it's an option. Thanks for reading :)",
        image: $64e9af93c06761bd$var$gbaImg,
        imageAlt: "A Modded GameBoy Advance"
    },
    "2026-07-16": {
        title: "Magic and Pok\xe9mon",
        link: "magic_and_pokemon",
        description: "Just like Fortnite all over again",
        body: "So my hobbies have definitely been going all over lately, but I love it! One day I was at my girlfriend's house; her brother (the GOAT) asked me if I wanted to play a game of Magic: The Gathering, and I said sure. I've been wanting to learn how to play, but the opportunity never came up, but this was the night that changed. He has about eight commander decks, so I wasn't sure what to choose, but I went ahead and chose the Mothman precon. That match was certainly something. I won, but I cheated and didn't realize it until the day after, but that game lasted two hours....TWO HOURS. So, as smart people would do, we played two more matches! We started playing at 9 pm, and we finished our last game at 2 am. During one of the games, we decided we wanted to go to an LCS (shoutout LifeLink Games) and go look and maybe buy some cards. So we get to the store, and I ended up buying the Avengers Assemble precon, sleeves, and a binder for a master set for Pok\xe9mon. While I was checking out the precons, a guy came up to me and asked if Jackson and I wanted to play, and we were like, sure. So we played a three-way commander game that lasted for two hours, so we were there for a little bit longer than I thought, but I had so much fun. The next week, I went to work at a summer camp, and during the camp, while I had downtime, I started to play Pok\xe9mon! Now I've played Pok\xe9mon before, but it's been off and on. I've had a lot of fun playing, though, and it was super refreshing. So now I'm building decks for Pok\xe9mon, upgrading my precon, and looking for new precons that I might want to get! Thanks for reading :)",
        image: $64e9af93c06761bd$var$cardsImg,
        imageAlt: "Two cards, captain america, team leader from magic the gathering and mega lucario ex from pokemon"
    },
    "2026-08-08": {
        title: "Adventures throughout the DMV",
        link: "adventures_dmv",
        description: "I've done a lot of things in the past month",
        body: "A little while after my last blog post, my family and my girlfriend\u2019s family went on a beach trip to the Outer Banks, specifically Nags Head! I\u2019ve been going on this trip for about three years now, but this year was extra special because it was the first time my family got to come along. We had an amazing time filled with great food, fun activities, and plenty of time at the beach. Unfortunately, we got rained on for the last two days, but honestly, that just gave us an excuse to stay inside and play video and card games together, which ended up being just as much fun. We spent a whole week in Nags Head, and then the next Friday, Landry and I headed to Richmond to see Pond and Djo in concert! IT WAS SO GOOD. I didn\u2019t really know what kind of music Pond made going into the concert, but I thoroughly enjoyed their set. Djo was fantastic as well. Hearing those songs live was such an amazing experience, and it was definitely one of the many highlights of the summer. Then, the following Tuesday, Landry\u2019s family and I headed to Baltimore to watch an Orioles game before spending some time in Ocean City, Maryland. I had never been to Ocean City before, so I was excited to see what it was like. The boardwalk was definitely something I hadn\u2019t experienced before! Between the restaurants, arcades, rides, and seagulls, there was always something to entertained by. This past month has been a blast! I\u2019ve made a lot of great memories. Now, though, it\u2019s time to start thinking about school again! Thanks for reading :)"
    },
    "2026-08-15": {
        title: "Reading!",
        link: "reading!",
        description: "Actually enjoyed my first book for once",
        body: "I'm going to start this out by saying before I read Dungeon Crawler Carl, I didn't read books, nor did I even like reading books. While I was at Nags Head, I decided that when I was on the beach, I wasn't going to be on my phone. On the second day of being at the beach (the first day was just unpacking), we went to the Local Target, and I was searching around for Dungeon Crawler Carl. Jackson suggested it to me. He isn't a big reader, but it's one of his favorite books, so I decided to go ahead and get it. I was very hesitant to start the book, but once I did, I couldn't put it down. Of course, I put it down when we went to eat or do other stuff, but I brought it with me to stores in case I got bored. If you don't know what Dungeon Crawler Carl is, the main character, Carl (duh), and his ex's cat, Princess Donut, have to fight their way through a dungeon to survive. How did this dungeon appear, you might ask? Earth was harvested of all it's resources, which killed anybody that was inside of buildings or such, to build this dungeon. It features goblins to drug-dealing llamas, it really is an adventure. The book was so good I got the second one. I'm determined to read the rest of the series, other Matt Dinniman stories, and maybe even other books entirely! I haven't been this excited about reading in a LONG time. Thanks for reading :)",
        image: $64e9af93c06761bd$var$dccImg,
        imageAlt: "Dungeon Crawler Carl and Carl's Doomsday Scenario book covers"
    },
    "2026-08-27": {
        title: "NES Restoration",
        link: "nes_restoration",
        description: "Found an old NES and restored it!",
        body: "So, my brother recently acquired my grandmother's house, and let me tell you, THIS THING WAS TRASHED. But as my family was rummaging through everything, they found an old NES. We weren't sure if it worked, so we put it aside until we could clean it. A few days later, my mom and I sat down to clean the thing, and it was disgusting. There was mouse poop in the ventilation, along with dirt and hair inside the console. After getting it cleaned up, we realized we only had the console and one game, so my dad went out and bought a controller and power adapter. Once my dad got home, we turned it on, and it kind of worked. The screen was distorted, but there was at least a picture, so we knew there was hope. We had to move the game cartridge around quite a bit, but eventually, we got it to display correctly. After doing some research, we found out that it's a common problem for the 72-pin connector to go bad, so my mom ordered a replacement. The new connector arrived, we installed it, and now the NES works like a charm! I can't wait to get some more games for it. It's been a blast so far playing Super Mario Bros. Thanks for reading :)",
        image: $64e9af93c06761bd$var$nesImg,
        imageAlt: "Picture of NES working with a monitor"
    }
};

});
parcelRegister("6Q70Z", function(module, exports) {
module.exports = import.meta.resolve("lhJgp");

});

parcelRegister("1qv1G", function(module, exports) {
module.exports = import.meta.resolve("gk3zq");

});

parcelRegister("6gAfJ", function(module, exports) {
module.exports = import.meta.resolve("7pkCz");

});

parcelRegister("iEm8A", function(module, exports) {
module.exports = import.meta.resolve("iDrAe");

});



var $8F9Ib = parcelRequire("8F9Ib");
const $48588e9c923a5848$var$svgArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 64 64"><path stroke="none" fill="#02577a" d="M23.339745962156 9.5240473580836a10 10 0 0 1 17.320508075689 0l20.179491924311 34.951905283833a10 10 0 0 1 -8.6602540378444 15l-40.358983848622 0a10 10 0 0 1 -8.6602540378444 -15"></path></svg>`;
const $48588e9c923a5848$var$POSTS_PER_PAGE = 5;
let $48588e9c923a5848$var$currentPage = 0;
let $48588e9c923a5848$var$sortedEntries = [];
function $48588e9c923a5848$var$loadBlogPage() {
    $48588e9c923a5848$var$sortedEntries = Object.entries((0, $8F9Ib.blogs)).sort(([dateA], [dateB])=>new Date(dateB) - new Date(dateA));
    $48588e9c923a5848$var$renderPage($48588e9c923a5848$var$currentPage);
}
function $48588e9c923a5848$var$renderPage(page) {
    const blogArea = document.querySelector("#blog-area");
    blogArea.innerHTML = "";
    const start = page * $48588e9c923a5848$var$POSTS_PER_PAGE;
    const end = start + $48588e9c923a5848$var$POSTS_PER_PAGE;
    const pageEntries = $48588e9c923a5848$var$sortedEntries.slice(start, end);
    for (const [date, blog1] of pageEntries)blogArea.appendChild($48588e9c923a5848$var$createBlogCard(date, blog1));
    $48588e9c923a5848$var$renderPagination(page);
}
function $48588e9c923a5848$var$renderPagination(page) {
    const pagination = document.querySelector("#blog-pagination");
    pagination.innerHTML = "";
    const totalPages = Math.ceil($48588e9c923a5848$var$sortedEntries.length / $48588e9c923a5848$var$POSTS_PER_PAGE);
    const prevBtn = document.createElement("button");
    prevBtn.classList.add("pagination-arrow-btn", "pagination-arrow-btn--prev");
    prevBtn.disabled = page === 0;
    prevBtn.innerHTML = $48588e9c923a5848$var$svgArrow;
    prevBtn.addEventListener("click", ()=>{
        $48588e9c923a5848$var$currentPage--;
        $48588e9c923a5848$var$renderPage($48588e9c923a5848$var$currentPage);
    });
    const pageLabel = document.createElement("span");
    pageLabel.classList.add("text");
    pageLabel.textContent = `${page + 1} / ${totalPages}`;
    const nextBtn = document.createElement("button");
    nextBtn.classList.add("pagination-arrow-btn", "pagination-arrow-btn--next");
    nextBtn.disabled = page >= totalPages - 1;
    nextBtn.innerHTML = $48588e9c923a5848$var$svgArrow;
    nextBtn.addEventListener("click", ()=>{
        $48588e9c923a5848$var$currentPage++;
        $48588e9c923a5848$var$renderPage($48588e9c923a5848$var$currentPage);
    });
    pagination.appendChild(prevBtn);
    pagination.appendChild(pageLabel);
    pagination.appendChild(nextBtn);
}
function $48588e9c923a5848$var$createBlogCard(date, blog1) {
    const link = document.createElement("a");
    link.href = `/blog/${blog1.link}`;
    link.classList.add("text-decoration-none", "blog-card-link");
    const card = document.createElement("div");
    card.classList.add("card");
    const title = document.createElement("h2");
    title.textContent = blog1.title;
    title.classList.add("heading", "mb-1");
    card.appendChild(title);
    const description = document.createElement("p");
    description.textContent = blog1.description;
    description.classList.add("text", "m-0");
    card.appendChild(description);
    const dateEl = document.createElement("p");
    dateEl.textContent = $48588e9c923a5848$var$formatDate(date);
    dateEl.classList.add("subtext", "m-0");
    card.appendChild(dateEl);
    link.appendChild(card);
    return link;
}
function $48588e9c923a5848$var$formatDate(dateString) {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
    });
}
function $48588e9c923a5848$var$loadBlogPost() {
    const blogpost = document.querySelector("#blog-post");
    const name = $48588e9c923a5848$var$getBlogFolderName();
    for (blog of Object.entries((0, $8F9Ib.blogs)))if (blog.link == name) {
        const title = document.createElement("h1");
        title.textContent = blog.title;
        title.classList.add("blog-heading", "pt-1", "text-center");
        blogpost.appendChild(title);
        if (blog.image) {
            const img = document.createElement("img");
            img.src = blog.image;
            img.alt = blog.imageAlt;
            img.className = "blog-image";
            blogpost.appendChild(img);
        }
        const text = document.createElement("p");
        text.textContent = blog.body;
        text.className = "blog-text";
        blogpost.appendChild(text);
    }
}
function $48588e9c923a5848$var$getBlogFolderName() {
    const segments = window.location.pathname.split("/").filter((s)=>s);
    let last = segments[segments.length - 1];
    if (last === "index.html") {
        segments.pop();
        last = segments[segments.length - 1];
    }
    return last;
}
$48588e9c923a5848$var$loadBlogPage();


//# sourceMappingURL=blog.85e30454.js.map
